import type { PanelMenuDesignTokens } from '@primeuix/themes/types/panelmenu';

/**
 * PanelMenu component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/panelmenu/index.ts
 *
 * Component documentation:
 * https://primeng.org/panelmenu
 */
export const panelmenuComponentTokens: Partial<PanelMenuDesignTokens> = {
  root: {
    transitionDuration: '50ms',
  },
  item: {
    padding: '0.75rem',
  },
};
